module.exports = __webpack_public_path__ + "static/media/masthead-north-west-telegraph.fe24a207.svg";